import UserListPage from "./pages/UserListPage";
import UserCreatePage from "./pages/UserCreatePage";
import UserDetailPage from "./pages/UserDetailPage";
import UserLogPage from "./pages/UserLogPage";


export const userRoutes = (prefix = "users") => [
  {
    name: "UserCreatePage",
    path: `${prefix}/create`,
    component: UserCreatePage
  },
  { name: "UserLogPage", path: `${prefix}/:id/log`, component: UserLogPage },
  { name: "UserDetailPage", path: `${prefix}/:id`, component: UserDetailPage },
  { name: "UserListPage", path: prefix, component: UserListPage }
];
